// Highcharts v12: re-trigger chart animation when switching back to a Chart tab.
// Applies to any tab pane with one of the animation marker classes:
//   .horizontal-bar-animation  — horizontal bar charts
//   .vertical-bar-animation    — vertical column charts
//   .horizontal-plot-animation — line/area/stock charts
// On tab show, finds any Highcharts chart rendered inside the pane and replays its animation.
if ($('.horizontal-bar-animation, .vertical-bar-animation, .horizontal-plot-animation').find('.chart').length > 0) {

$(document).on('shown.bs.tab', '[data-toggle="tab"]', function () {
    var paneId = $(this).attr('href');
    var $pane = $(paneId);

    if (!$pane.is('.horizontal-bar-animation, .vertical-bar-animation, .horizontal-plot-animation')) {
        return;
    }

    $pane.find('.chart').each(function () {
        var el = this;
        var chart = Highcharts.charts.find(function (c) { return c && c.renderTo === el; });
        if (!chart) { return; }

        var isBarColumn = chart.series.some(function (s) {
            return s.visible && (s.type === 'bar' || s.type === 'column');
        });

        if (isBarColumn) {
            // Bar/column: animate each series independently
            chart.series.forEach(function (s) {
                s.finishedAnimating = false;
                s.animate(true);
                s.animate();
            });
        } else {
            // Line/area/stock: reset the shared SVG clip rects directly, bypassing
            // the finishedAnimating flag and series animation API
            Object.keys(chart.sharedClips || {}).forEach(function (key) {
                var clip = chart.sharedClips[key];
                clip.attr({ width: 0 });
                clip.animate({ width: chart.plotWidth }, { duration: 1000 });
            });
        }
    });
});

}
